import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  BarChart3Icon, 
  UsersIcon, 
  CreditCardIcon, 
  SettingsIcon, 
  HelpCircleIcon, 
  LifeBuoyIcon, 
  UserIcon, 
  BuildingIcon, 
  Users as UsersGroupIcon, 
  PackageIcon,
  FileTextIcon,
  WalletIcon
} from 'lucide-react';
const Sidebar = () => {
  const location = useLocation();
  const navItems = [{
    icon: <HomeIcon size={20} />,
    label: 'Dashboard',
    path: '/dashboard'
  }, {
    icon: <BarChart3Icon size={20} />,
    label: 'Revenue',
    path: '/revenue'
  }, {
    icon: <UsersIcon size={20} />,
    label: 'Customers',
    path: '/customers'
  }, {
    icon: <BuildingIcon size={20} />,
    label: 'Tenants',
    path: '/tenants'
  }, {
    icon: <UsersGroupIcon size={20} />,
    label: 'Users',
    path: '/users'
  }, {
    icon: <CreditCardIcon size={20} />,
    label: 'Subscriptions',
    path: '/subscriptions'
  }, {
    icon: <PackageIcon size={20} />,
    label: 'Plans',
    path: '/plans'
  }, {
    icon: <FileTextIcon size={20} />,
    label: 'Invoices',
    path: '/invoices'
  }, {
    icon: <WalletIcon size={20} />,
    label: 'Payments',
    path: '/payments'
  }, {
    icon: <UserIcon size={20} />,
    label: 'My Profile',
    path: '/profile'
  }, {
    icon: <SettingsIcon size={20} />,
    label: 'Settings',
    path: '/settings'
  }];
  return <aside className="hidden md:flex flex-col w-64 bg-white border-r border-gray-200">
      <div className="p-4 border-b border-gray-200">
        <h1 className="text-xl font-bold text-blue-600">SubMetrics</h1>
        <p className="text-xs text-gray-500 mt-1">Subscription Analytics</p>
      </div>
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map(item => <li key={item.path}>
              <Link to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${location.pathname === item.path ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`}>
                <span className="mr-3">{item.icon}</span>
                {item.label}
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-pointer">
          <span className="mr-3">
            <HelpCircleIcon size={20} />
          </span>
          Help Center
        </div>
        <div className="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-pointer">
          <span className="mr-3">
            <LifeBuoyIcon size={20} />
          </span>
          Support
        </div>
      </div>
    </aside>;
};
export default Sidebar;